import { Component, input } from '@angular/core';
import { NumberDisplayComponent } from 'app/driver-pay/persistence/core/components/displays/NumberDisplay.component';
import { DisplayComponent } from './DisplayComponent';

@Component({
  selector: 'number-display-blank-if-zero',
  standalone: true,
  imports: [NumberDisplayComponent],
  template: `
    @if (isZero()) {
      <span>&nbsp;</span>
    } @else {
      <number-display [id]="id()" [value]="value()" />
    }
  `,
})
export class NumberDisplayBlankIfZeroComponent implements DisplayComponent {
  id = input<string | undefined>();
  value = input.required<object | undefined>();

  isZero(): boolean {
    const val = this.value();
    if (val === undefined || val === null) {
      return false;
    }

    const num = Number(val);
    return !Number.isNaN(num) && num === 0;
  }
}
